// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
/**
 * Situação da encomenda
 */
export enum PackageStatus {
  Extraviada = 'Extraviada',
  Enviada = 'Enviada',
  Nova = 'Nova',
  EmProcessamento = 'EmProcessamento',
  Entregue = 'Entregue',
  Cancelada = 'Cancelada',
  AguardandoRetiradaDestinatario = 'AguardandoRetiradaDestinatario',
  EmDevolucao = 'EmDevolucao',
  Devolvida = 'Devolvida',
  EmDevolucaoParaRemetente= 'EmDevolucaoParaRemetente',
  DevolvidaParaRemetente = 'DevolvidaParaRemetente',
  NaoColetada = 'NaoColetada',
  Pendente = 'Pendente',
  AguardandoPostagem = 'AguardandoPostagem',
  Expirada = 'Expirada',
  Bloqueada = 'Bloqueada',
}
